/**
 * Get the current timestamp with Czech time zone offset.
 */
export const getTimestampWithCzechOffset = () => {
  const date = new Date();

  // Get the current timestamp in milliseconds since the Unix epoch.
  const timestamp = Date.now();

  // Get the current date in the Czech time zone.
  // Czech users can be in different time zones, so we need to get the current date in the Czech time zone.
  const czechDate = new Date(
    date.toLocaleString("en-US", {timeZone: "Europe/Prague"}),
  );

  // Czech offset in milliseconds.
  const czechOffset = czechDate.getTimezoneOffset() * 60 * 1000 * -1;

  return timestamp + czechOffset;
};
